import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  ref: "refTarget",
  class: "absolute flex h-3 w-3 -right-1 -top-1"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "relative inline-flex rounded-full h-3 w-3 bg-red-500"
}, null, -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.dots[_ctx.target] ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_4, 512)) : _createCommentVNode("", true);
}